import { GraduationCap, BookOpen, CreditCard } from "lucide-react";

import DataFetcherTemplateHome from "../../hooks/DataFetcherTemplateHome";
import BlockImageCabecera from "../../components/BlockImageCabecera";
import Block3Columns from "../../components/Block3Columns";
import ConectUs from "../../components/ConectUs";
import OfferPosgrados from "../../components/view/OfferPosgrados";
import { motion } from "framer-motion";
import PosgradoPagos from "../../components/PosgradoPagos";

const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/template_home/51ae7ef1-57ff-440d-a341-a7a7bd441116" +
  "?include=field_imagen_portada.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

function Posgrados() {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
        when: "beforeChildren",
        staggerChildren: 0.2,
      },
    },
  };

  const DataDisplay = ({ data }) => (
    <div>
<div className="mt-10">
      <img src={data.imagen_portada} alt="cabecera" /> </div>
 

      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#004270] via-[#002f52] to-slate-950 p-8 md:p-12 shadow-xl border border-[#febe10]/20 max-w-5xl mx-auto my-8"
      >
        {/* Efectos de luz de fondo institucionales */}
        <div className="absolute top-0 right-0 -mt-12 -mr-12 w-72 h-72 bg-[#febe10]/10 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 left-0 -mb-12 -ml-12 w-72 h-72 bg-[#004270]/40 rounded-full blur-3xl pointer-events-none" />

        {/* Inyección de HTML con estilos usando colores de la UTPL */}
        <div
          dangerouslySetInnerHTML={{ __html: data.bloque1 }}
          className="relative z-10 flex flex-col items-start gap-6
      
      /* Estilos para el Periodo (p) - Badge en Amarillo UTPL */
      [&_h4]:text-xs 
      [&_h4]:font-bold 
      [&_h4]:tracking-widest 
      [&_h4]:uppercase 
      [&_h4]:text-[#febe10] 
      [&_h4]:bg-[#febe10]/10 
      [&_h4]:px-3 
      [&_h4]:py-1.5 
      [&_h4]:rounded-full 
      [&_h4]:border 
      [&_h4]:border-[#febe10]/30
      
      /* Estilos para el Título (h2) */
      [&_h2]:text-2xl 
      [&_h2]:md:text-3xl 
      [&_h2]:font-bold 
      [&_h2]:text-white 
      [&_h2]:tracking-tight 
      [&_h2]:leading-tight
      [&_h2]:max-w-3xl
      [&_h2]:m-0
       [&_h2_strong]:text-[#febe10]
      
      /* Estilos para el Botón si viene como enlace (a) */
      [&_a]:inline-flex 
      [&_a]:items-center 
      [&_a]:justify-center 
      [&_a]:px-6 
      [&_a]:py-3 
      [&_a]:mt-2
      [&_a]:text-sm 
      [&_a]:font-bold 
      [&_a]:text-slate-900 
      [&_a]:bg-[#febe10] 
      [&_a]:hover:bg-[#e0a60b] 
      [&_a]:rounded-xl 
      [&_a]:shadow-lg 
    
      [&_a]:transition-all 
      [&_a]:duration-200 
      [&_a]:hover:scale-[1.02]"
        />
      </motion.div>
      <div
        className="max-w-5xl m-auto text-center mt-10"
        dangerouslySetInnerHTML={{
          __html: data.bloque2,
        }}
      />
    </div>
  );

  return (
    <>
      <DataFetcherTemplateHome url={url}>
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplateHome>

      <div className="pb-16 pt-4">
        <OfferPosgrados></OfferPosgrados>
      </div>

      <div className="px-6">
        <PosgradoPagos></PosgradoPagos>
      </div>
      <div className="padding2">
        <ConectUs
          lema="Descubre contenido exclusivo, mantente al tanto de las últimas novedades y únete a nuestra comunidad de estudiantes de posgrado."
          instagram="https://www.instagram.com/utplposgrados/"
          facebook="https://www.facebook.com/utplposgrados"
        ></ConectUs>
      </div>
    </>
  );
}

export default Posgrados;
